import { createSlice } from '@reduxjs/toolkit';

import reexportSelector from '../utils/reexportSelector.js';
import { REQUESTS } from '../views/constants.js';

const initialState = Object.values(REQUESTS).reduce(
  (all, value) =>
    Object.assign(all, {
      [value]: {
        isActive: false,
        payload: {},
        timeFinish: -1,
        timeStart: -1,
        error: null
      }
    }),
  {}
);
const reexport = reexportSelector('network');

export const networkSlice = /** @type {import('@reduxjs/toolkit').Slice} */ (
  createSlice({
    name: 'network',
    initialState,
    reducers: {
      start: (state, { payload: { key, startTime, payload = {} } }) => {
        state[key].isActive = true;
        state[key].startTime = startTime;
        state[key].payload = payload;
        state[key].error = null;
      },
      finish: (state, { payload: { key, startTime, error } }) => {
        if (startTime !== state[key].startTime) {
          return;
        }

        state[key].isActive = false;
        state[key].payload = {};
        state[key].error = error;
        state[key].timeFinish = Date.now();
      }
    }
  })
);
export const { finish, start } = networkSlice.actions;

export const hasActiveRequest = reexport(state =>
  Object.values(state).some(({ isActive }) => isActive)
);
export const getRequest = requestType => reexport(state => state[requestType]);

export default networkSlice.reducer;
